import { render, staticRenderFns } from "./categoriesT2PDI.vue?vue&type=template&id=3c84511a"
import script from "./categoriesT2PDI.vue?vue&type=script&lang=js"
export * from "./categoriesT2PDI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports